import React, { ChangeEvent, useState } from 'react';
import { useRouter } from 'next/router';
import { dateFormatter } from '@/utils/date';

function useSearchPost<Type>({
  options,
  pathname,
}: {
  options?: Type;
  pathname: string;
}) {
  const router = useRouter();
  const [queryOptions, setQueryOptions] = useState<any>({
    ...options,
    is_open: 'all',
    started_at: new Date(),
    ended_at: new Date(),
  });

  const handleOptions = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setQueryOptions((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (queryOptions.is_open === 'all') {
      delete queryOptions.is_open;
    }
    if (queryOptions.started_at) {
      queryOptions.started_at = `${dateFormatter({
        date: queryOptions.started_at,
        format: 'YYYY-MM-DD',
      })} 00:00:00`;
    }
    if (queryOptions.ended_at) {
      queryOptions.ended_at = `${dateFormatter({
        date: queryOptions.ended_at,
        format: 'YYYY-MM-DD',
      })} 23:59:59`;
    }
    if (pathname === 'notice' || pathname === 'free' || pathname === 'event') {
      queryOptions.type = pathname;
    }

    router.push({
      pathname: `/admin/${pathname}/`,
      query: {
        ...queryOptions,
      },
    });
  };

  return { queryOptions, setQueryOptions, handleOptions, handleSearch };
}

export default useSearchPost;
